<template>
  <button class="btn btn--back" @click="goBack">
    Back
  </button>
</template>

<script>
  export default {
    name: "GoBack",
    data() {
      return {}
    },
    methods: {
      goBack() {
        this.$router.go(-1)
      },
    },
  }
</script>

<style lang="scss"></style>
